import { cloneDeep } from 'lodash'
export const inputForm = cloneDeep({
  currentMonthAmount: '', // 每月年金领取
  assumeInflationRate: '' // 通货膨胀率

})

// 以当前生活水平，您希望养老金每月可领取 下快速填充按钮组
export const formItemBtn = cloneDeep([{
  name: '10,000元/月',
  count: 10000
}, {
  name: '20,000元/月',
  count: 20000
}, {
  name: '30,000元/月',
  count: 30000
}])

// 底部按钮数组
export const btnList = cloneDeep([
  { name: '返回', btnType: 'reset' },
  { name: '查看分析', btnType: 'confirm' },
])

// 底部按钮数组
export const btnSettingList = cloneDeep([
  { name: '取消', btnType: 'no', disabled: false },
  { name: '查看分析', btnType: 'cat', disabled: true },
  { name: '确定', btnType: 'ok', disabled: true },
])

export const ChartEnum2 = {
  age: '',
  lifeMny: '寿险保额', // 寿险保额
  cashValue: '当年账户现金价值', // 当年账户现金价值
  yearMny: '年缴保费' // 年缴保费
}

// 底部按钮数组
export const optBtnList = cloneDeep([
  { name: '养老需求测算', btnType: 'demand', path: '/pension/card/demand' },
  { name: '养老供给测算', btnType: 'supply', path: '/pension/card/supply' },
  // { name: '年金产品选择', btnType: 'productSelect', path: '' },
  { name: '年金产品选择', btnType: 'productSelect', path: '' },
  { name: '生成报告', btnType: 'report', path: '' }
])

// 通货膨胀率下单选按钮组
export const radioList = cloneDeep([{
  type: 'default',
  name: '使用默认值'
}, {
  type: 'customize',
  name: '自定义通货膨胀率'
}])

// 指标参考
export const indexList = [{ name: '指标参考' }, { name: '隐藏指标' }]
